// extracted by mini-css-extract-plugin
export var container = "_mu-0";
export var dotAnimation = "_mu-2";
export var dotsLoading = "_mu-1";